var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7481D4F175F497Fa3Ca635D9Ea8974D559A00Bf54762Cdfe73Ec49Ac971C04F3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8247 22.9536C18.4166 22.9536 22.9497 18.4205 22.9497 12.8286C22.9497 7.23673 18.4166 2.70361 12.8247 2.70361C7.23282 2.70361 2.69971 7.23673 2.69971 12.8286C2.69971 18.4205 7.23282 22.9536 12.8247 22.9536Z",
    stroke: "#AD2226",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2996 24.2977L21.5996 21.5977",
    stroke: "#AD2226",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7481D4F175F497Fa3Ca635D9Ea8974D559A00Bf54762Cdfe73Ec49Ac971C04F3);
export default __webpack_public_path__ + "static/media/7481d4f175f497fa3ca635d9ea8974d559a00bf54762cdfe73ec49ac971c04f3.35c8e40fedc179d16269a61aadfb16b9.svg";
export { ForwardRef as ReactComponent };